var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_4150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0074 8.9353L19.4925 22.5725M21.8741 26.9116L21.1937 25.6719M9.62578 4.59619L10.3062 5.83594M18.7142 27.0328L23.6732 24.3109M7.82675 7.19687L12.7857 4.47501M7.6683 11.3169L16.3465 6.55367M15.1534 24.9541L23.8316 20.1909",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_4150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7.58594 0.876953) rotate(16.2387)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.864d91edaa0f8c12bc52883ffa0fa6ef.svg";
export { ForwardRef as ReactComponent };